import RoleActions from './RoleActions';

const AdminRoutesWithRole = [
  {
    path: '/admin/dashboard',
    roleAction: RoleActions.DASHBOARD
  },
  /* dv2_temporary_solution */
  {
    path: '/admin/problemEditor/new',
    roleAction: RoleActions.PROBLEM_EDITOR
  },
  {
    path: '/admin/problems',
    roleAction: RoleActions.ALL_PROBLEMS
  },
  {
    path: '/admin/challengeEditor',
    roleAction: RoleActions.CHALLENGE_EDITOR
  },
  {
    path: '/admin/dv2_challenge_list',
    roleAction: RoleActions.ALL_CHALLENGES
  },
  {
    path: '/admin/dv2-challenge-score',
    roleAction: RoleActions.DV2_CHALLENGE_SCORE
  },
  {
    path: '/admin/jobEditor',
    roleAction: RoleActions.JOB_EDITOR
  },
  {
    path: '/admin/jobList',
    roleAction: RoleActions.JOB_LIST
  },
  {
    path: '/admin/jobApplyList',
    roleAction: RoleActions.JOB_APPLY_LIST
  },
  {
    path: '/admin/designChallengeList',
    roleAction: RoleActions.DESIGN_CHALLENGE_LIST
  },
  {
    path: '/admin/mcqScoreSummary',
    roleAction: RoleActions.MCQ_SCORE_SUMMARY
  },
  {
    path: '/admin/bugReport',
    roleAction: RoleActions.BUG_REPORT_LIST
  },
  {
    path: '/admin/qaAccount',
    roleAction: RoleActions.QA_ACCOUNTS_LIST
  },
  {
    path: '/admin/challengeStatistics',
    roleAction: RoleActions.CHALLENGE_STATISTICS
  },
  {
    path: '/admin/resetCandidateTest',
    roleAction: RoleActions.RESET_CANDIDATE_TEST
  },
  {
    path: '/admin/updateSeniority',
    roleAction: RoleActions.UPDATE_DEVELOPER_SENIORITY
  },
  {
    path: '/admin/mcqStatusUpdate',
    roleAction: RoleActions.SETUP_MCQ_ROLE_PREFERED
  },
  {
    path: '/admin/areaRelationship',
    roleAction: RoleActions.SETUP_LABEL_AREA_RELATIONSHIP
  },
  {
    path: '/admin/mcqSurvey',
    roleAction: RoleActions.MCQ_SURVEY
  },
  {
    path: '/admin/updateMCQScore',
    roleAction: RoleActions.UPDATE_MCQ_SCORE
  },
  {
    path: '/admin/challengeABTestConfig',
    roleAction: RoleActions.CHALLENGE_AB_TEST_CONFIGURATION
  },
  {
    path: '/admin/mcqCopyEditor',
    roleAction: RoleActions.MCQ_COPY_EDITOR
  },
  {
    path: '/admin/impersonateUser',
    roleAction: RoleActions.LOGIN_AS_USER
  },
  {
    path: '/admin/setupStackDemand',
    roleAction: RoleActions.SETUP_STACK_DEMAND
  },
  {
    path: '/admin/interviewEligibility',
    roleAction: RoleActions.INTERVIEW_ELIGIBILITY
  },
  {
    path: '/admin/updateCandidatesStatus',
    roleAction: RoleActions.UPDATE_CANDIDATES_STATUS
  },
  {
    path: '/admin/live/setup',
    roleAction: RoleActions.LIVE_CODE_INTERVIEW
  },
  {
    path: '/admin/setupAvailability',
    roleAction: RoleActions.SETUP_AVAILABILITY
  },
  {
    path: '/admin/account-management',
    roleAction: RoleActions.ACCOUNT_MANAGEMENT
  },
  {
    path: '/admin/booked-event',
    roleAction: RoleActions.ADMIN_LIST_BOOKED_EVENT
  },
  {
    path: '/admin/calendar/setup/new',
    roleAction: RoleActions.ADMIN_CALENDAR_SETUP
  },
  {
    path: '/admin/calendar/list',
    roleAction: RoleActions.ADMIN_LIST_CALENDARS
  },
  {
    path: '/admin/user-profile-view',
    roleAction: RoleActions.USER_PROFILE_VIEW
  },
  {
    path: '/admin/create-account-by-resume',
    roleAction: RoleActions.USER_PROFILE_VIEW
  },
  {
    path: '/admin/s-param-management',
    roleAction: RoleActions.USER_PROFILE_VIEW
  },
  {
    path: '/admin/display-mcq-questions',
    roleAction: RoleActions.USER_PROFILE_VIEW
  },
  {
    path: '/admin/programming-languages',
    roleAction: RoleActions.USER_PROFILE_VIEW
  },
  {
    path: '/admin/interviewer-performance',
    roleAction: RoleActions.INTERVIEWER_PERFORMANCE_REPORT
  },
  {
    path: '/admin/interviewer-availability',
    roleAction: RoleActions.INTERVIEWER_AVAILABILITY_REPORT
  },
  {
    path: '/admin/user-profile-view',
    roleAction: RoleActions.USER_PROFILE_VIEW
  },
  {
    path: '/admin/setup-skill-relationship',
    roleAction: RoleActions.SETUP_SKILL_RELATIONSHIP
  },
  {
    path: '/admin/setup-skill-mcq-relationship',
    roleAction: RoleActions.SETUP_SKILL_MCQ_RELATIONSHIP
  },
  {
    path: '/admin/setup-demand-stack-skill',
    roleAction: RoleActions.SETUP_DEMAND_STACK_SKILL
  },
  {
    path: '/admin/job_search',
    roleAction: RoleActions.JOB_SEARCH
  },
  {
    path: '/admin/cms',
    roleAction: RoleActions.CONTENT_MANAGEMENT_SYSTEM
  },
  {
    path: '/admin/change-candidate-email',
    roleAction: RoleActions.CHANGE_CANDIDATE_EMAIL
  },
  {
    path: '/admin/customized-vetting',
    roleAction: RoleActions.VETSMITH
  },
  {
    path: '/admin/ci-labs-profiles',
    roleAction: RoleActions.CLOUD_INSTITUTE
  },
  {
    path: '/admin/ci-labs-instances',
    roleAction: RoleActions.CLOUD_INSTITUTE
  },
  {
    path: '/admin/delete-user-account',
    roleAction: RoleActions.DELETE_USER
  },
  /* A FEW ROLE PATH MISSING HERE */
  /* End dv2_temporary_solution */
];

export {
  AdminRoutesWithRole
};
